<ion-content class="ion-padding s-super-social">
  <section>
    <usucampeao-header title="Programa para moradores em vulnerabilidade"></usucampeao-header>

    <usucampeao-detalhes-super-social></usucampeao-detalhes-super-social>

    <ion-item lines="none">
      <ion-checkbox mode="md" slot="start" [(ngModel)]="superSocialAceito"></ion-checkbox>
      <ion-label>Li e aceito os termos de participação no programa Super Social</ion-label>
    </ion-item>

    <usucampeao-footer>
      <ion-button class="ion-margin-vertical" mode="md" [disabled]="!superSocialAceito"
        (click)="solicitarSuperSocial()">
        Confirmar adesão ao programa
      </ion-button>
      <ion-button mode="md" fill="outline">
        Voltar
      </ion-button>
    </usucampeao-footer>
  </section>
</ion-content>